import React from 'react';
import axios from "../../../../containers/api";
import {Button, FormGroup, Input, Label} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";

class EditMainBranch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            AgentMainToEdit: this.props && this.props.AgentMainToEdit
        }
    }

    EditAgentMain = () => {
        if (this.state.AgentMainToEdit.agentMainName.length < 6) {
            this.props.showAlert("نام دفتر مرکزی نمی‌تواند کمتر از ۶ حرف باشد.", "error")
        } else if (this.state.AgentMainToEdit.agentMainNationID.length < 10 || this.state.AgentMainToEdit.agentMainNationID.length > 11) {
            this.props.showAlert("کد ملی نباید کمتر از ۱۰ حرف و بیشتر از ۱۱ حرف باشد.", "error");
        } else {
            this.props.showSpinner();
            axios.post('api/AgencyApi/UpdateAgencyMainBranch', this.state.AgentMainToEdit)
                .then((res) => {
                    this.props.hideSpinner();
                    this.props.showAlert("دفتر مرکزی با موفقیت ویرایش شد", "success");
                    this.props.closeModal("EditModal");
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    this.props.showAlert(showCatchError(error), "error");
                    console.log(error.response);
                });
        }
    };

    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainName} maxLength={150}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainName: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام کامل مدیر مرکز</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainManagerName} maxLength={100}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainManagerName: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainNationID} maxLength={50}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainNationID: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, "")) }})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد اقتصادی</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainEconomic} maxLength={50}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainEconomic: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, "")) }})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>فکس</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainFax} maxLength={50}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainFax: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, "")) }})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تلفن</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainTel} maxLength={50}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainTel: toEnglishNumbers(e.target.value.replace(/[^0-9۰-۹]/g, "")) }})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>ایمیل</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainEmailAddress} maxLength={50}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainEmailAddress: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>وبسایت</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainWebAddress} maxLength={50}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainWebAddress: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>

                    <FormGroup className="w-md-50 w-100 px-1">
                        <Label>آدرس</Label>
                        <Input value={this.state.AgentMainToEdit.agentMainAddress} maxLength={550}
                               onChange={(e) => this.setState({AgentMainToEdit: {...this.state.AgentMainToEdit, agentMainAddress: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>
                </div>

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.EditAgentMain()}>
                            ذخیره
                        </Button>
                    </FormGroup>
                </div>
            </div>
        );
    }
}

export default EditMainBranch;